import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { EyeOutlined } from "@ant-design/icons";

import CopyText from "./CopyText";
import Preview from "./Preview";

const GeneratedHtml = () => {
  const [showPreview, setShowPreview] = useState(true);
  const generatedHtml = useSelector(
    (state) => state.WebToLeadReducer.generatedHtml
  );
  const isScript = !generatedHtml.includes("<html")

  useEffect(() => {
    setShowPreview(!isScript);
  }, [isScript]);

  return (
    <div className="generate-html mt40">
      <div
        style={{ borderBottom: "0.20000000298023224px solid #e1e1e1" }}
        className="d-flex align-items-center justify-content-between title"
      >
        <div className="text-color-1C1C1C heading18px roboto-medium">
          Generated {isScript ? "Script" : "HTML"}
        </div>
        <div className="d-flex align-items-center" style={{ gap: 20 }}>
          {!isScript && (
            <div
              className={`preview ${showPreview && "preview-active"}`}
              onClick={() => setShowPreview(true)}
            >
              <EyeOutlined />
            </div>
          )}
          <CopyText
            text={generatedHtml}
            callback={() => setShowPreview(false)}
          />
        </div>
      </div>
      {showPreview ? (
        <div className="overflow-y-scroll d-flex justify-content-center" style={{ padding: 20 }}>
          <Preview generatedHtml={generatedHtml} />
        </div>
      ) : (
        <div className="w-100 title">
          <pre>
            <code style={{ color: "#959595" }}>{generatedHtml}</code>
          </pre>
        </div>
      )}
    </div>
  );
};

export default GeneratedHtml;
